import React, {useEffect, useState} from 'react';
import {
    AppBar, BottomNavigation, BottomNavigationAction, CircularProgress,
    Container, IconButton,
    Link,
    ThemeProvider,
    Toolbar,
    Typography
} from "@mui/material";
import {Navigate, Route, Routes} from "react-router-dom";
import LoginPage from "./Pages/LoginPage";
import PaymentPage from "./Pages/PaymentPage";
import CreateAccountPage from "./Pages/CreateAccountPage";
import IndexPage from "./Pages/IndexPage";
import PurchaseMembershipPage from "./Pages/PurchaseMembershipPage";
import {Person} from "@mui/icons-material";
import {useUserDataContext, useUserLoginContext} from "./Contexts/UserContext";
import PaymentCompletePage from "./Pages/PaymentCompletePage";
import {useNavigate} from "react-router";
import SelectMembershipPage from "./Pages/SelectMembershipPage";
import StripePortalPage from "./Pages/StripePortalPage";
import {createHQTheme} from "./theme";
import {useSiteDataContext} from "./Contexts/SiteDataContext";
import {theatres} from "./theatres";
import InternalLogin from "./Pages/InternalLogin";
import {useBasketContext} from "./Contexts/BasketContext";
import CustomerSearchPage from "./Pages/CustomerSearch";

function App() {
    const user = useUserDataContext();
    const navigate = useNavigate();
    const setUser = useUserLoginContext();
    const siteData = useSiteDataContext();
    const basket = useBasketContext();
    useEffect(() => {
        if (user?.site) {
            siteData.setSite(user.site);
        }
    }, [user?.site]);
    const [theme, setTheme] = useState(null);
    useEffect(() => {
        if (siteData?.siteData) {
            var sd = siteData.siteData;
            const newTheme = createHQTheme(sd);
            setTheme(newTheme);
            document.getElementById('shortcut0')?.setAttribute('href', sd.shortcutLogo??'');
            document.getElementById('shortcut1')?.setAttribute('href', sd.shortcutLogo??'');
            document.getElementById('theme-color')?.setAttribute('content', newTheme.palette.primary.main);
            document.title = sd.name + ' Membership';
        }
    }, [siteData?.siteData])
    if (!siteData.siteData || !theme) {
        return <div style={{height:'100vh',width:'100vw',display:'flex',justifyContent:'center',alignItems:'center'}}><CircularProgress/></div>;
    }
    return (
        <ThemeProvider theme={theme}>
            <>
                <AppBar position="sticky" sx={(theme)=>({
                    background: siteData?.siteData?.headerColour??'',
                    //"linear-gradient(180deg, #236B76 0%, #18525E 100%)",
                    marginBottom: theme.spacing(6)
                })}>
                    <Container maxWidth="md">
                        <Toolbar disableGutters>
                            <Typography
                                noWrap
                                component="a"
                                href={siteData.siteData.siteUrl!}
                                sx={(theme) => ({
                                    paddingTop: theme.spacing(3),
                                    paddingBottom: theme.spacing(3)
                                })}
                            >
                                <img alt="Back to site" src={siteData.siteData.logo!}
                                     style={{maxHeight: '100px', maxWidth: '300px'}}/>
                            </Typography>
                            {user != null &&
                              <Typography sx={{
                                  flexGrow: 1,
                                  justifyContent: "flex-end",
                                  alignItems: "center",
                                  display: {xs: 'none', md: 'flex'}
                              }} variant="body1"
                              ><Link href="#" underline="always" variant="inherit"
                                                       sx={(theme) => ({paddingLeft: theme.spacing(2), color: '#FFF'})}
                                                       onClick={
                                                           () => {
                                                               setUser(null);
                                                               basket.setCustomer(null);
                                                               basket.setSubscription(null);
                                                               basket.setPaymentIntent(null);
                                                               siteData.setSite(document.location.hostname);
                                                               if(user.internal) {
                                                                   navigate('/internal');
                                                               } else {
                                                                   navigate(siteData.siteData?.siteUrl??'/');
                                                               }
                                                           }
                                                       }>Logout</Link></Typography>
                            }
                        </Toolbar>
                    </Container>
                </AppBar>
                <Routes>
                    <Route path="/internal/login" element={<InternalLogin/>}/>
                    <Route path="/login" element={<LoginPage/>}/>
                    <Route path="/purchase-subscription" element={<PurchaseMembershipPage/>}/>
                    <Route path="/internal/search" element={<CustomerSearchPage/>}/>
                    <Route path="/payment" element={<PaymentPage/>}/>
                    <Route path="/create-account" element={<CreateAccountPage/>}/>
                    <Route path="/complete" element={<PaymentCompletePage/>}/>
                    <Route path="/select-membership" element={<SelectMembershipPage/>}/>
                    <Route path="/stripe-portal" element={<StripePortalPage/>}/>
                    <Route index element={<IndexPage/>}/>
                    <Route
                        path="/internal"
                        element={<Navigate to="/internal/login" replace />}
                    />
                    <Route path="*" element={<Navigate to="/" replace />}/>
                </Routes>
                {false && !user?.internal &&
                  <AppBar position="fixed" color="primary" sx={{top: 'auto', bottom: 0}}>
                    <Container maxWidth="md">
                      <Toolbar disableGutters>
                          {theatres.map((theatre) => (
                              <IconButton color="inherit" aria-label="open drawer" onClick={() => {
                                  siteData.setSite(theatre.name);
                                  basket.setSubscription(null);
                                  basket.setPaymentIntent(null);
                              }}>
                                  <img alt="" style={{maxWidth: "50px"}} src={theatre.logo}/>
                              </IconButton>
                          ))}
                      </Toolbar>
                    </Container>
                  </AppBar>
                }
            </>
        </ThemeProvider>
    );
}

export default App;
